export default "__VITE_ASSET__BSfKBYPK__"